import React, { useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_perfect-match-17/artifacts/y8zcv9ti_Logo.png"
              alt="Logo"
              className="h-10 w-auto mr-3"
            />
            <div className="text-2xl font-bold text-slate-800">
              RÉSIDENCE <span className="text-amber-600">NATOMA</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('project')}
              className="text-slate-700 hover:text-amber-600 transition-colors duration-300"
            >
              Le Projet
            </button>
            <button 
              onClick={() => scrollToSection('floor-plan')}
              className="text-slate-700 hover:text-amber-600 transition-colors duration-300"
            >
              Plans
            </button>
            <button 
              onClick={() => scrollToSection('virtual-tour')}
              className="text-slate-700 hover:text-amber-600 transition-colors duration-300"
            >
              Visite 360°
            </button>
            <button 
              onClick={() => scrollToSection('payment')}
              className="text-slate-700 hover:text-amber-600 transition-colors duration-300"
            >
              Paiement
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-slate-700 hover:text-amber-600 transition-colors duration-300"
            >
              Contact
            </button>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-slate-600">
              <Phone className="h-4 w-4" />
              <span className="text-sm">+221 78 717 28 28</span>
            </div>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-amber-600 hover:bg-amber-700 text-white"
            >
              Réserver
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-slate-700"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200">
          <div className="px-4 py-2 space-y-2">
            <button 
              onClick={() => scrollToSection('project')}
              className="block w-full text-left px-3 py-2 text-slate-700 hover:text-amber-600"
            >
              Le Projet
            </button>
            <button 
              onClick={() => scrollToSection('floor-plan')}
              className="block w-full text-left px-3 py-2 text-slate-700 hover:text-amber-600"
            >
              Plans
            </button>
            <button 
              onClick={() => scrollToSection('virtual-tour')}
              className="block w-full text-left px-3 py-2 text-slate-700 hover:text-amber-600"
            >
              Visite 360°
            </button>
            <button 
              onClick={() => scrollToSection('payment')}
              className="block w-full text-left px-3 py-2 text-slate-700 hover:text-amber-600"
            >
              Paiement
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-3 py-2 text-slate-700 hover:text-amber-600"
            >
              Contact
            </button>
            <div className="flex items-center space-x-2 px-3 py-2 text-slate-600">
              <Phone className="h-4 w-4" />
              <span className="text-sm">+221 78 717 28 28</span>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;